<template>
  <div
    class="item"
    :class="{
      active: item && getCurrentStep.id === item.id,
      warning: item && item.warning,
      error: item && item.error && !item.warning
    }"
    @click.self="$emit('changeStep', item)"
  >
    <div class="item-content">
      <Picture :url="item.icon || ''" class="picture" />
      <p class="item-content__text" @click.self="$emit('changeStep', item)">
        {{ item.name || item.lbl.value }}
      </p>
    </div>
    <Checkbox
      v-if="item.skip"
      :value="Number(item.required)"
      @change="$emit('changeRequired', !item.required, item.id)"
    />
  </div>
</template>
<script>
import { store } from '@/store';
import Picture from 'Elements/Picture/Picture';
import Checkbox from 'Elements/Checkbox/CustomCheckbox';

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    getCurrentStep() {
      return store.state.common.generalStepsDialog.currentStep;
    }
  },
  methods: {},
  components: {
    Picture,
    Checkbox
  }
};
</script>
<style lang="scss" scoped>
.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  height: 72px;
  background-color: $white;
  border-bottom: 1px solid $black-20;
  font-style: normal;
  font-weight: 800;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;

  &:hover {
    .item-content__text {
      color: $black-200;
    }
  }

  &-content {
    display: flex;
    cursor: pointer;
    align-items: center;

    .picture {
      filter: $bluePicture;
    }

    &__text {
      margin-left: 16px;
      max-width: 186px;
      word-break: break-word;
      color: $black-100;
      cursor: pointer;
    }
  }
}

.active {
  background-color: $blue-10 !important;

  .item-content__text {
    color: $black-200 !important;
    font-weight: 800;
  }
}

.warning {
  background-color: $yellow-10;

  .item-content {
    .picture {
      filter: $YellowPicture;
    }

    &__text {
      color: $black-200;
      font-weight: 800;
    }
  }
}

.error {
  background-color: $red-10;
  margin-bottom: 0;
  .item-content {
    .picture {
      filter: $RedPicture;
    }

    &__text {
      color: $red;
      font-weight: 800;
    }
  }
}
</style>
